import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header/Header";
import { useLocation } from "react-router-dom";
import VerifyModal from "../components/modals/VerifyModal";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import PublicSidebar from "./PublicSidebar";
import Footer from "../components/Footer";
// import { Helmet } from "react-helmet";
// import { Maintenance } from "../pages/pageListAsync";

const DefaultDashboard = () => {
  const [isOpen, setIsOpen] = useState(
    window?.innerWidth > 1024 ? false : true,
  );
  const [openVerifyKyc, setOpenVerifyKyc] = useState(true);
  const location = useLocation();
  const getToken =
    sessionStorage.getItem("referredAs") == "User"
      ? Cookies.get("accessToken")
      : Cookies.get("pfaccessToken");
  const { userData } = useSelector((state) => state?.user || {});

  useEffect(() => {
    const handleResize = () => {
      if (window?.innerWidth > 1024) {
        setIsOpen(true);
      }
    };

    window?.addEventListener("resize", handleResize);

    return () => {
      window?.removeEventListener("resize", handleResize);
    };
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     await dispatch(fetchUserData());
  //     setLoading(false);
  //   };

  //   fetchData();
  // }, [dispatch]);

  const isVerify = userData?.isVerified;
  const toggleSidebar = () => {
    setIsOpen((prevState) => !prevState);
  };
  return (
    <>
      {/* <Helmet>
        <title>MST DefaultDashboard</title>
        <meta name="title" content="MST DefaultDashboard" />
        <meta name="description" content="MST DefaultDashboard description" />
        <meta name="keywords" content="keywords" />
        <meta
          property="og:title"
          content="MST Blockchain DefaultDashboard | Next-Gen Layer 1 Blockchain Platform"
        />
        <meta
          property="og:description"
          content="MST Blockchain DefaultDashboard is a sustainable Layer 1 platform offering low-cost solutions, Web3 infrastructure, and decentralized tools for enterprises, retail, and gaming."
        />
        <meta
          property="og:image"
          content="https://opengraph.b-cdn.net/production/images/1ef80874-b041-4ff5-9d15-163cdeff83e7.png?token=bIxS4DV7UepnCj05maLG3hVZmnG5pabhIbhRXgETTo8&height=630&width=1200&expires=33293930066"
        />
        <meta property="og:url" content="https://mstblockchain.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:logo"
          content="https://opengraph.b-cdn.net/production/images/1ef80874-b041-4ff5-9d15-163cdeff83e7.png?token=bIxS4DV7UepnCj05maLG3hVZmnG5pabhIbhRXgETTo8&height=630&width=1200&expires=33293930066"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="mstblockchain.com" />
        <meta property="twitter:url" content="https://mstblockchain.com/" />
        <meta
          name="twitter:title"
          content="MST Blockchain DefaultDashboard | Next-Gen Layer 1 Blockchain Platform"
        />
        <meta
          name="twitter:description"
          content="MST Blockchain is a sustainable Layer 1 platform offering low-cost solutions, Web3 infrastructure, and decentralized tools for enterprises, retail, and gaming."
        />
        <meta
          name="twitter:image"
          content="https://opengraph.b-cdn.net/production/images/1ef80874-b041-4ff5-9d15-163cdeff83e7.png?token=bIxS4DV7UepnCj05maLG3hVZmnG5pabhIbhRXgETTo8&height=630&width=1200&expires=33293930066"
        />
      </Helmet> */}

      <div className="portalcss min-h-[100dvh] flex flex-col">
        <Header
          toggleSidebar={toggleSidebar}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          isVerify={isVerify}
          userData={userData}
          getToken={getToken}
        />
        <div className={`flex flex-1 ${isOpen ? "side-open" : ""}`}>
          <div
            className={`absolute md:relative ${
              !isOpen
                ? "top-[80px] md:top-0 bottom-0 left-0 transition-all duration-75 w-[240px] md:w-[230px] lg:w-[280px]"
                : "w-[0px] lg:w-[60px] transition-all duration-75"
            } z-20 lg:border-r lg:border-r-white`}
          >
            <PublicSidebar
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              isVerify={isVerify}
              getToken={getToken}
            />
          </div>
          <div
            className={`md:flex-1 bg-[#0F0F0F] relative z-10 w-full flex flex-col ${
              !isOpen && "blur-sm md:blur-0"
            } ${isOpen ? "blur-0" : "md:blur-0"}`}
          >
            <div className="flex-1 overflow-auto p-8 px-3 lg:px-12">
              <Outlet />
            </div>
            <Footer />

            <div className="fixed right-0 bottom-0 w-full z-[-2]">
              <img
                loading="lazy"
                src="/images/wave.png"
                alt="Wave background"
                className="w-full select-none"
              />
            </div>

            {location.pathname !== "/" && (
              <>
                <div className="absolute right-[50px] bottom-[40px] z-[-1]">
                  <img
                    loading="lazy"
                    src="/images/outlit/bigbox.png"
                    alt="Decoration"
                    className="w-[85px] opacity-[0.2] select-none lg:opacity-100"
                  />
                </div>
                <div className="absolute right-[165px] bottom-[112px] z-[-1]">
                  <img
                    loading="lazy"
                    src="/images/outlit/smallbox.png"
                    alt="Decoration"
                    className="w-[50px] opacity-[0.2] select-none lg:opacity-100"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {!isVerify && getToken && (
        <VerifyModal open={openVerifyKyc} setOpen={setOpenVerifyKyc} />
      )}
    </>
  );
};

export default DefaultDashboard;
